import { render, staticRenderFns } from "./Crew.vue?vue&type=template&id=5276b1a3&"
import script from "./Crew.vue?vue&type=script&lang=js&"
export * from "./Crew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports